import React from 'react';
import { cn } from "../../lib/utils";
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";
import { Clock, TrendingUp, TrendingDown } from "lucide-react";
import { format } from "date-fns";

export default function AlertCard({ alert }) {
    const isBuy = alert.signal === 'BUY';

    // Format the text to preserve line breaks and emojis
    const formattedText = alert.text?.split('\n').map((line, i) => (
        <span key={i}>
            {line}
            {i < alert.text.split('\n').length - 1 && <br />}
        </span>
    ));

    return (
        <Card className={cn(
            "overflow-hidden border-0 transition-all duration-300 hover:scale-[1.01]",
            isBuy
                ? "bg-gradient-to-br from-emerald-950/80 to-emerald-900/40 ring-1 ring-emerald-500/30"
                : "bg-gradient-to-br from-red-950/80 to-red-900/40 ring-1 ring-red-500/30"
        )}>
            <div className="p-5">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className={cn(
                            "w-10 h-10 rounded-lg flex items-center justify-center",
                            isBuy ? "bg-emerald-500/20" : "bg-red-500/20"
                        )}>
                            {isBuy ? (
                                <TrendingUp className="w-5 h-5 text-emerald-400" />
                            ) : (
                                <TrendingDown className="w-5 h-5 text-red-400" />
                            )}
                        </div>
                        <div>
                            <Badge
                                className={cn(
                                    "font-bold text-sm px-3 py-1",
                                    isBuy
                                        ? "bg-emerald-500 hover:bg-emerald-500 text-white"
                                        : "bg-red-500 hover:bg-red-500 text-white"
                                )}
                            >
                                {alert.signal}
                            </Badge>
                        </div>
                    </div>

                    <div className="flex items-center gap-4">
                        <Badge variant="outline" className="border-slate-600 text-slate-300">
                            {alert.pair}
                        </Badge>
                        <Badge variant="outline" className="border-slate-600 text-slate-400">
                            {alert.timeframe}
                        </Badge>
                    </div>
                </div>

                {/* Alert Text - displayed exactly as received */}
                <div className={cn(
                    "rounded-lg p-4 font-mono text-sm leading-relaxed whitespace-pre-wrap",
                    isBuy ? "bg-emerald-950/50" : "bg-red-950/50",
                    "text-slate-200"
                )}>
                    {formattedText}
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-slate-700/50">
                    <div className="flex items-center gap-2 text-slate-400 text-sm">
                        <Clock className="w-4 h-4" />
                        <span>{alert.alert_time || format(new Date(alert.created_date), 'yyyy-MM-dd HH:mm')}</span>
                    </div>
                    {alert.indicator && (
                        <span className="text-xs text-slate-500">
                            {alert.indicator}
                        </span>
                    )}
                </div>
            </div>
        </Card>
    );
}
